import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { API_URL, securityHeaders } from '../Constants';
import { isEmpty } from 'lodash';

const fetchCalendarByMonth = async (type, year) => {
  return await axios.get(
    API_URL + `/api/Calendar/GetCalendar/${type}/${year}`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchCalendarByDay = async (type, year, searchTerm) => {
  return await axios.get(
    API_URL +
      `/api/Calendar/GetCalendarCMS/${type}/${year}${
        !isEmpty(searchTerm) ? `?Search=${searchTerm}` : ''
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchCalendarPoster = async (type, year) => {
  return await axios.get(
    API_URL + `/api/Calendar/GetCaledarPosterByTypeandYear/${type}/${year}`,
    {
      headers: securityHeaders,
    }
  );
};

const addCalendar = (values) => {
  return axios.post(API_URL + `/api/Calendar/Calendar`, values, {
    headers: securityHeaders,
  });
};

const deleteCalendar = (calendarId) => {
  return axios.post(
    API_URL + `/api/Calendar/DeleteCalendar/${calendarId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useAddCalendar = () => {
  return useMutation(addCalendar);
};

export const useDeleteCalendar = (calendarId) => {
  return useMutation(() => deleteCalendar(calendarId));
};

export const useFetchCalendarByMonth = (type, year) => {
  return useQuery({
    queryKey: ['calendarMonth'],
    queryFn: () => fetchCalendarByMonth(type, year),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchCalendarByDay = (type, year, searchTerm) => {
  return useQuery({
    queryKey: ['calendarDay'],
    queryFn: () => fetchCalendarByDay(type, year, searchTerm),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchCalendarPoster = (type, year) => {
  return useQuery({
    queryKey: ['calendarPoster'],
    queryFn: () => fetchCalendarPoster(type, year),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

//add calendar poster
const addCalendarPoster = (values) => {
  return axios.post(API_URL + `/api/Calendar/CalendarPoster`, values, {
    headers: securityHeaders,
  });
};

export const useAddCAlendarPoster = () => {
  return useMutation(addCalendarPoster);
};

const exportCalendarPoster = async ({ year, type }) => {
  const response = await axios.get(
    API_URL + `/api/Export/ExportCalendar/${year}/${type}`,
    {
      headers: securityHeaders,
      responseType: 'blob',
    }
  );
  return response.data;
};

export const useExportCalendarPoster = () => {
  return useMutation((params) => exportCalendarPoster(params));
};

const deleteAcademicYear = (yearId) => {
  return axios.post(
    API_URL + `/api/Settings/DeleteAcademicYear/${yearId}`,
    {},
    { headers: securityHeaders }
  );
};

export const useDeleteAcademicYear = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (yearId) => deleteAcademicYear(yearId),
    onSuccess: () => {
      queryClient.invalidateQueries(['academicYears']);
    },
  });
};
const deleteCalendarPoster = ({ yearId, type }) => {
  return axios.post(
    API_URL + `/api/Calendar/DeleteCalendarPoster/${yearId}/${type}`,
    {},
    { headers: securityHeaders }
  );
};

export const useDeleteCalendarPoster = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ type, yearId }) => deleteCalendarPoster({ yearId, type }),
    onSuccess: () => {
      queryClient.invalidateQueries(['calendarPoster']);
    },
  });
};
const setAcademicYearAsDefault = (yearId) => {
  return axios.post(
    API_URL + `/api/Settings/SetAcademicYearAsDefault/${yearId}`,
    {},
    { headers: securityHeaders }
  );
};

export const useSetAcademicYearAsDefault = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (yearId) => setAcademicYearAsDefault(yearId),
    onSuccess: () => {
      queryClient.invalidateQueries(['academicYears']);
    },
  });
};
const fetchAcademicYearsWithCounts = async (type) => {
  return axios.get(
    API_URL + `/api/Settings/GetAcademicYearsWithCounts/${type}`,
    { headers: securityHeaders }
  );
};

export const useFetchAcademicYearsWithCounts = (type) => {
  return useQuery({
    queryKey: ['academicYears', 'withCounts', type],
    queryFn: () => fetchAcademicYearsWithCounts(type),
    enabled: type !== null && type !== undefined,
    refetchOnWindowFocus: false,
  });
};
